import { Injectable } from '@angular/core';
import { L7Response } from '@biz-models/network/l7-response.model';
import { changePasswordReq } from '@biz-models/network/login-authenticate-network.model';
import { Observable } from 'rxjs';
import { ApiService } from 'src/controls/api/shared/api.service';
import { AjaxService } from './ajax.service';
const _MICROSERVICE = 'sso-ms';
@Injectable({
	providedIn: 'root',
})
export class ForgetPasswordService {
	constructor(private ajax: AjaxService, private apiService: ApiService) {}

	forgetPassword(data: any): Observable<any> {
		return this.ajax.post('sso', 'auth/password/forget', data);
	}

	resetPassword(data: any) {
		return this.apiService.post$<L7Response<any>>(_MICROSERVICE, 'auth/password/reset', data);
	}

	changePassword(data: any) {
		return this.apiService.post$<L7Response<any>>(_MICROSERVICE, 'user/change-password', data);
	}
}
